<template minapp='mpx' xlang='wxml'>
  <es-transition
    custom-style="{{customStyle}}"
    show="{{show}}"
    custom-class="{{classname}}"
    bind:click="onClick"
    >
      <slot></slot>
  </es-transition>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    props: {
      show: Boolean,
      customStyle: null
    },

    computed: {
      classname() {
        return this.$classnames('es-overlay').join(' ')
      }
    },

    methods: {
      onClick() {
        this.$trigger('click')
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>
<script  type='application/json' lang='json'>
{
 "component": true,
 "usingComponents": {
    "es-transition": "../transition/index",
  }
}
</script>

